import * as YAML from "yaml";
import * as nodeUtils from "./utils/nodeUtils";
import * as pathUtils from "./utils/pathUtils";
import * as typeUtils from "./utils/typeUtils";
import * as accessor from "./modelYamlAccessor";

//----------------------------------------------------------------------------------

export const exportToYaml = (root) => {
  const _model = {};

  parseGlobalParameters(root, _model);
  parseFunctions(root, _model);

  return YAML.stringify(_model, { collectionStyle: "any" });
};

const parseGlobalParameters = (root, results) => {
  const _globalParameters = nodeUtils.getParameters(root);

  if (_globalParameters.length > 0) {
    accessor.setGlobalParameters(
      results,
      _globalParameters.map((e) => parseParameter(e))
    );
  }
};

const parseFunctions = (root, results) => {
  const _functions = nodeUtils.getFunctions(root);

  if (_functions.length > 0) {
    accessor.setFunctions(
      results,
      _functions.map((e) => parseFunction(e))
    );
  }
};

const parseFunction = (node) => {
  const _results = {};

  _results[typeUtils.getTypeFunction()] = nodeUtils.getName(node);

  parseParameters(node, _results);
  parseChoices(node, _results);
  parseConditions(node, _results);

  return _results;
};

const parseConditions = (element, results) => {
  const _conditions = nodeUtils.getConditions(element);

  if (_conditions.length > 0) {
    const _conditionsParsed = [];
    _conditions.forEach((e) => parseCondition(e, _conditionsParsed));
    accessor.setConditions(results, _conditionsParsed);
  }
};

const parseCondition = (condition, conditionsParsed) => {
  let _results = {};

  const _name = nodeUtils.getName(condition);
  const _type = nodeUtils.getType(condition);
  const _expression = nodeUtils.getExpression(condition);

  _results[_type] = _name;

  const _label = nodeUtils.getLabel(condition);

  if (_label.length > 0) {
    accessor.setLabel(_results, _label);
  }

  accessor.setExpression(_results, _expression);

  conditionsParsed.push(_results);
};

const parseParameters = (container, results) => {
  const _parameters = nodeUtils.getParameters(container);

  if (_parameters) {
    accessor.setParameters(
      results,
      _parameters.map((e) => parseParameter(e))
    );
  }
};

const parseParameter = (parameter) => {
  const _type = nodeUtils.getType(parameter);

  let _results;

  switch (_type) {
    case typeUtils.getTypeParameter():
    case typeUtils.getTypeParameterGlobal():
      _results = parseParameterDefault(parameter);
      break;
    case typeUtils.getTypeParameterLinked():
      _results = parseParameterLinked(parameter);
      break;
    case typeUtils.getTypeParameterOutput():
      _results = parseParameterOutput(parameter);
      break;
    default:
      throw new Error("Unknown parameter type!");
  }

  const _label = nodeUtils.getLabel(parameter);

  if (_label.length > 0) {
    accessor.setLabel(_results, _label);
  }

  accessor.setComment(_results, nodeUtils.getComment(parameter));

  return _results;
};

const parseParameterDefault = (parameter) => {
  const _results = {};

  _results[typeUtils.getTypeParameter()] = nodeUtils.getName(parameter);

  parseParameters(parameter, _results);
  parseChoices(parameter, _results);
  parseConditions(parameter, _results);

  return _results;
};

const parseParameterLinked = (parameter) => {
  const _results = {};

  _results[typeUtils.getTypeParameterLinked()] = nodeUtils.getName(parameter);

  accessor.setIdTarget(_results, pathUtils.getName(nodeUtils.getIdTarget(parameter)));

  return _results;
};

const parseParameterOutput = (parameter) => {
  const _results = {};

  _results[typeUtils.getTypeParameterOutput()] = nodeUtils.getName(parameter);

  accessor.setValueDefault(_results, nodeUtils.getValueDefault(parameter));

  return _results;
};

const parseChoices = (container, results) => {
  const _choices = nodeUtils.getChoices(container);

  if (_choices.length > 0) {
    accessor.setChoices(
      results,
      _choices.map((e) => parseChoice(e))
    );
  }
};

const parseChoice = (choice) => {
  const _type = nodeUtils.getType(choice);

  const _results = {};

  _results[_type] = nodeUtils.getName(choice);

  accessor.setValue(_results, nodeUtils.getValue(choice));

  const _label = nodeUtils.getLabel(choice);

  if (_label.length > 0) {
    accessor.setLabel(_results, _label);
  }

  accessor.setComment(_results, nodeUtils.getComment(choice));

  parseChoices(choice, _results);

  return _results;
};
